import { i18n } from "@lingui/core";
import React from 'react';
import * as CommonComponents from '@prezi/common-components';
import { useRTL } from '@prezi/common-components';
import styled from 'styled-components';
import { isNil } from 'ramda';
import { DropdownSelect } from '@prezi/bento';
import * as Atoms from '../../atoms';
import { createDataLookup, TOOLTIP_ROOT } from '../../const';
import { PermissionValueNoAccess } from '../../../utils/permissions';
import { localI18n } from '../../../i18n';
const Wrapper = styled.div.withConfig({
  displayName: "OrgCollaborator__Wrapper",
  componentId: "sc-1dibdyu-0"
})(["display:flex;align-items:center;margin:20px 0 4px 0;"]);
const DetailsWrapper = styled.div.withConfig({
  displayName: "OrgCollaborator__DetailsWrapper",
  componentId: "sc-1dibdyu-1"
})(["display:flex;align-items:center;flex:1 1 auto;padding-inline-start:8px;"]);
const SelectWrapper = styled.div.withConfig({
  displayName: "OrgCollaborator__SelectWrapper",
  componentId: "sc-1dibdyu-2"
})(["flex:1 1 130px;display:flex;justify-content:flex-end;margin-inline-end:-8px;"]);
const uxCopy = {
  noAccess: localI18n._("no access"),
  team: localI18n._("team")
};
const addRemoveOption = options => {
  return options.concat([{
    value: PermissionValueNoAccess.NO_ACCESS,
    label: uxCopy.noAccess
  }]);
};
export default (({
  teamName,
  caption,
  permission,
  onChange,
  onRemove,
  permissionOptions,
  isDisabled = false
}) => {
  const {
    isRTL
  } = useRTL();
  const handleOnChange = permission => {
    if (permission === PermissionValueNoAccess.NO_ACCESS) {
      onRemove();
    } else {
      onChange(permission);
    }
  };
  return React.createElement(Wrapper, null, React.createElement(DetailsWrapper, null, React.createElement(Atoms.Dumb.TeamAvatar, null), React.createElement(CommonComponents.UserDisplayContainer, null, React.createElement(CommonComponents.UserDisplayName, {
    size: 14
  }, `${teamName} ${uxCopy.team}`), React.createElement(CommonComponents.UserDisplayCaption, {
    size: 12
  }, caption))), React.createElement(SelectWrapper, null, React.createElement(DropdownSelect, {
    options: addRemoveOption(permissionOptions),
    value: !isNil(permission) ? permission.value : PermissionValueNoAccess.NO_ACCESS,
    disabled: isDisabled,
    portalRoot: TOOLTIP_ROOT,
    onChange: handleOnChange,
    dataLookup: createDataLookup('organization-collaborator-permissions-select'),
    placeholder: i18n._("Select..."),
    outline: false,
    align: isRTL ? 'left' : 'right',
    fitItems: true
  })));
});